'use client'
import dynamic from 'next/dynamic'

type NoSsrProps = {
  children: React.ReactNode
}

function NoSsr({ children }: NoSsrProps) {
  return children
}

export default dynamic(() => Promise.resolve(NoSsr), { ssr: false })
